import * as msal from "@azure/msal-browser";
import env from "./env.js";

(async () => {
    const authenv = (window.location.hostname.includes("staging.gls-pakete.de") || window.location.hostname.includes("gls.freshfiles.de")) ? env.staging : env.prod

    const b2cPolicies = {
        names: {
            signUpSignIn: authenv.SIGN_IN_POLICY
        },
        authorities: {
            signUpSignIn: {
                authority: `https://${authenv.AUTHORITY_DOMAIN}/${authenv.TENANT_NAME}.onmicrosoft.com/${authenv.SIGN_IN_POLICY}`,
            }
        },
        scopes: [
            `${authenv.SCOPE_URL}/GLSAPP-READ`,
            `${authenv.SCOPE_URL}/GLSAPP-WRITE`,
        ],
        authorityDomain: `${authenv.AUTHORITY_DOMAIN}`,
    };

    const msalConfig = {
        auth: {
            clientId: authenv.CLIENT_ID,
            authority: b2cPolicies.authorities.signUpSignIn.authority,
            knownAuthorities: [b2cPolicies.authorityDomain],
            redirectUri: window.location.origin + '/' + ((document.querySelector('html').getAttribute('lang').substring(0,2).toLowerCase() === 'de') ? '' : 'en/')  + 'process-login',
            postLogoutRedirectUri: window.location.origin + '/'
        },
        cache: {
            cacheLocation: 'localStorage',
            storeAuthStateInCookie: false
        },
    };

    const loginRequest = {
        scopes: b2cPolicies.scopes,
        prompt: 'login',
    };

    const msalInstance = new msal.PublicClientApplication(msalConfig);
    await msalInstance.initialize();

    const bindLoginButtons = () => {
        document.querySelectorAll('.g2clogin__loginbutton, .g2clogin__registerbutton').forEach((button) => {
            button.addEventListener('click', () => {
                msalInstance.loginRedirect(loginRequest);
                document.querySelector('.g2clogin--dropdown').classList.remove('g2clogin--dropdown--active')
            })
        })
    }

    const bindLogoutButtons = () => {
        document.querySelectorAll('.g2clogin__logoutbutton').forEach((button) => {
            button.addEventListener('click', () => {
                msalInstance.logoutRedirect({
                    'idTokenHint': msalInstance.getAllAccounts()[0].idToken
                });
            })
        })
    }

    document.addEventListener('DOMContentLoaded', () => {
        bindLoginButtons()
        bindLogoutButtons()
    })

    try {
        await msalInstance.handleRedirectPromise()
    } catch (e) {
        console.log('MSAL exception', e)
    }

}) ()